import config from '@/config'
import $store from '@/store.js'
import Outil from '@/assets/js/utils.js'

// 按钮背景色
export const BTNSTATUS = (status) => config.BtnStatus[status]
// 按钮名称
export const BTNNAME = (status) => config.BtnName[status]

export const WIDTHCLASS = (data) => {
  const { type } = data
  if (type === 'TVUPack' || type === 'TVUGrid') {
    if (type === 'TVUGrid') {
      return 'col-md-5 col-xs-5'
    } else if (data.status != 0) {
      return 'col-md-7 col-xs-7 line'
    } else {
      return 'col-md-7 col-xs-7'
    }
  } else {
    return 'col-md-6 col-xs-6'
  }
}

export const SHOWICON = (PeerObj) => {
  const obj = {}
  const data = {
    0: 'grayColor',
    1: 'greenColor',
    2: 'redColor'

  }
  // 根据状态绑定颜色
  Object.keys(data).forEach((v) => {
    if (PeerObj.status == v) {
      obj[data[v]] = true
    }
  })
  // 根据类型绑定icon图标
  switch (PeerObj.type) {
    case 'TVUPack':
    case 'T':
      obj.packIcon = true
      break
    case 'Ext':
      obj.extIcon = true
      break
    case 'YouTube':
      obj.youtubeIcon = true
      break
    case 'TVUGrid':
    case 'X':
      obj.packIcon = true
      break
    case 'LocalSDI':
      obj.localSDIIcon = true
      break
    case 'SMPTE2022':
      obj.extIcon = true
      break
    default: break
  }
  return obj
}

export const CANSUE = (item) => {
  const key = item.type
  const moudle = item.voipEnable ? 'VoIP' : 'IFB'
  if (key === 'TVUPack') {
    if (moudle == 'VoIP') {
      const enable = item.voipEnable
      if (enable && item.status != 0) {
        return false
      } else {
        return true
      }
    } else if (item.IFBProperty) {
      const enable = item.IFBProperty.IfbEnabled
      if (enable && item.status != 0) {
        return false
      } else {
        return true
      }
    } else {
      return true
    }
  }
}

export const RETURNSTATUS = (item) => {
  let _str = ''
  const { type } = item
  const module = item.voipEnable ? 'VoIP' : 'IFB'
  if (type === 'TVUPack') {
    if (module === 'VoIP') {
      if (item.voipSuccess || item.voipConnection) {
        _str = 'red'
      }
    } else if (item.IFBProperty) {
      if (item.IFBProperty.Color === 'Red') {
        _str = 'red'
      }
    }
  }
  return _str
}

export const SWITCHBUSSTATUS = (item) => {
  var _str = ''
  const { type } = item
  const { IsRemotePreload } = item
  if (type === 'TVUGrid') {
    if (IsRemotePreload) {
      _str = 'green switch'
    } else {
      _str = 'white switch'
    }
  } else {
    _str = 'hide'
  }
  return _str
}
// 显示home页面缩略图
export const SHOWDEVICEIMG = (item) => {
  let _url = ''
  const { blobUrl } = $store.state.common.baseUrl
  // const blobUrl = '10.12.23.99:55443/t';
  if (!item) return
  const { type } = item
  const { status } = item
  const header = window.location.protocol.includes('https') ? 'https://' : 'http://'
  const { isCompressThumbnail } = JSON.parse(localStorage.getItem('channelInitConfig')).urlInfo
  switch (type) {
    case 'T':
      if (status === '2') {
        // _url = header + blobUrl + "/" + item.livePeerId.toUpperCase() + "?" + Math.random();
        _url = `${header + blobUrl}/${item.livePeerId.toUpperCase()}?`
        _url = isCompressThumbnail == '0' ? `${_url}type=original&app=cc&${Math.random()}` : `${_url}${Math.random()}&app=cc`
      } else if (status === '0') {
        _url = config.DefaultImgByStatus.T[0]
      } else if (status === '3') {
        _url = config.DefaultImgByStatus.T[3]
      } else {
        // _url = header + blobUrl + "/" + item.peerId.toUpperCase() + "?" + Math.random();
        _url = `${header + blobUrl}/${item.peerId.toUpperCase()}?`
        _url = isCompressThumbnail == '0' ? `${_url}type=original&app=cc&${Math.random()}` : `${_url}${Math.random()}&app=cc`
      }
      break
    case 'X':
      if (status === '2') {
        // _url = header + blobUrl + "/" + item.peerId.toUpperCase() + "?" + Math.random();
        _url = `${header + blobUrl}/${item.livePeerId.toUpperCase()}?`
        _url = isCompressThumbnail == '0' ? `${_url}type=original&app=cc&${Math.random()}` : `${_url}${Math.random()}&app=cc`
      } else if (status === '0') {
        _url = config.DefaultImgByStatus.X[0]
      } else if (status === '3') {
        _url = config.DefaultImgByStatus.X[3]
      } else if (status === '1000') {
        _url = config.DefaultImgByStatus.X[1000]
      } else if (status === '1001') {
        _url = config.DefaultImgByStatus.X[1001]
      } else {
        // _url = header + blobUrl + "/" + item.peerId + "?" + Math.random();
        _url = `${header + blobUrl}/${item.peerId}?`
        _url = isCompressThumbnail == '0' ? `${_url}type=original&app=cc&${Math.random()}` : `${_url}${Math.random()}&app=cc`
      }
      break
    case 'YouTube':
      if (status === '1' || status === '0') {
        _url = config.DefaultImgByStatus.YouTube.img
      } else {
        // _url = header + blobUrl + "/" + item.livePeerId.split(';')[0].toUpperCase() + "?" + Math.random();
        _url = `${header + blobUrl}/${item.livePeerId.split(';')[0].toUpperCase()}?`
        _url = isCompressThumbnail == '0' ? `${_url}type=original&app=cc&${Math.random()}` : `${_url}${Math.random()}&app=cc`
      }
      break
    case 'Ext':
      if (status === '1' || status === '0') {
        _url = config.DefaultImgByStatus.Ext.img
      } else {
        // _url = header + blobUrl + "/" + item.livePeerId.split(';')[0].toUpperCase() + "?" + Math.random();
        _url = `${header + blobUrl}/${item.livePeerId.split(';')[0].toUpperCase()}?`
        _url = isCompressThumbnail == '0' ? `${_url}type=original&app=cc&${Math.random()}` : `${_url}${Math.random()}&app=cc`
      }
      break
    case 'SMPTE2022':
      if (status === '1' || status === '0') {
        _url = config.DefaultImgByStatus.SMPTE2022.img
      } else {
        // _url = header + blobUrl + "/" + item.livePeerId.split(';')[0].toUpperCase() + "?" + Math.random();
        _url = `${header + blobUrl}/${item.livePeerId.split(';')[0].toUpperCase()}?`
        _url = isCompressThumbnail == '0' ? `${_url}type=original&app=cc&${Math.random()}` : `${_url}${Math.random()}&app=cc`
      }
      break
    case null:
      if (status === '1' || status === '0') {
        _url = config.DefaultImgByStatus.Ext.img
      } else {
        // _url = header + blobUrl + "/" + item.livePeerId.split(';')[0].toUpperCase() + "?" + Math.random();
        _url = `${header + blobUrl}/${item.livePeerId.split(';')[0].toUpperCase()}?`
        _url = isCompressThumbnail == '0' ? `${_url}type=original&app=cc&${Math.random()}` : `${_url}${Math.random()}&app=cc`
      }
      break
    default: break
  }
  return _url
}

export const CHANGELANGUAGE = (value) => {
  const obj = {
    '英语(美国)': 'en-US',
    '日语(日本)': 'ja-JP',
    '葡萄牙语(葡萄牙)': 'pt-PT',
    '中文(简体，中国)': 'zh-Hans',
    'en-US': 'en-US',
    'ja-JP': 'ja-JP',
    'pt-PT': 'pt-PT',
    'zh-Hans': 'zh-Hans'
  }

  return obj[value]
}

export const FORMATSORT = (obj) => {
  let value
  config.SelectBySorts.forEach((v) => {
    if (obj[v.value]) {
      value = v.value
    }
  })
  if (!value) {
    value = 'nameFirst'
  }
  return value
}

export const FORMATROLE = (val, role) => {
  if (role == 1) return i18n.t(`lang.${config.ManageRoleType[val]}`)
  return i18n.t(`lang.${config.RoleType[val]}`)
}

export const SETTINGTYPE = (val) => {
  // console.log(val)
  const { type, platform, peerId } = val
  if (platform == 5001) {
    return i18n.t('lang.RPSEncoder')
  }
  if (platform == 5002) {
    return i18n.t('lang.RPSDecoder')
  }
  if (type == 'R') {
    return i18n.t('lang.receiver')
  }
  if (type == 'T') {
    let name
    if (platform < 10 || platform > 14) {
      name = 'TVUPack'
    }
    if (platform >= 10 && platform <= 14) {
      name = 'TVUAnywhere'
    }
    if (!platform) {
      name = 'unknow'
    }
    return i18n.t(`lang.${name}`)
  }
  if (type == 'X') {
    const str = peerId.substr(peerId.length - 1, 1)
    if (str == 1) {
      return i18n.t('lang.Grid-Pack')
    }
    if (str == 2) {
      return i18n.t('lang.Grid-SDI')
    }
  }
  if (type == 'Ext') {
    return 'Ext'
  }
  if (type == 'YouTube') {
    return 'YouTube'
  }
  if (type == 'SMPTE2022') {
    return 'Ext'
  }
}

// 时间戳格式化时间格式
export const DATE = (date, fmt) => {
  if (!date) { return '' }
  date = `${date}`
  if (date.length > 13) {
    date = date.slice(0, 13)
  }
  date = new Date(date * 1)

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${date.getFullYear()}`).substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = `${o[k]}`
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : (`00${str}`).substr(str.length))
    }
  }
  return fmt
}

// 时间戳格式化时间格式
export const UTCDATE = (date, fmt) => {
  if (!date) { return '' }
  date = `${date}`
  if (date.length > 13) {
    date = date.slice(0, 13)
  }
  date = new Date(date * 1)

  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (`${date.getUTCFullYear()}`).substr(4 - RegExp.$1.length))
  }
  const o = {
    'M+': date.getUTCMonth() + 1,
    'd+': date.getUTCDate(),
    'h+': date.getUTCHours(),
    'm+': date.getUTCMinutes(),
    's+': date.getUTCSeconds()
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = `${o[k]}`
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : (`00${str}`).substr(str.length))
    }
  }
  return fmt
}

export  const  MAPLOACTION  =   (obj)  =>  {
  const  value  =  obj.status  ==  1  ?   obj.automatic  :  obj.manual
  let   firstValue = value  &&  value.split(',')[0]
  firstValue = parseFloat(firstValue).toFixed(4)
  let  secondValue = value  &&  value.split(',')[1]
  secondValue = parseFloat(secondValue).toFixed(4)
  return  `${firstValue},${secondValue}`
}
export const BITRATE = (obj) => {
  if (obj.includes('K')) {
    obj = parseInt(obj.split('K')[0] || 0)
    const z = obj % 1024
    if (z === 0) {
      const n = obj / 1024
      return `${n}.0M`
    } else {
      return `${obj}K`
    }
  } else {
    return obj
  }
}
const DURATION = (mss) => {
  if (!mss) { return '-' }
  if (mss == '00:00:00' || mss == 0) return '00:00:00'
  let second = Math.ceil(mss / 1000)
  let minute = 0
  let hour = 0
  if (second > 0) {
    minute = parseInt(second / 60)
    second = parseInt(second % 60)
    if (minute > 60) {
      hour = parseInt(minute / 60)
      minute = parseInt(minute % 60)
    }
  }
  var time = ''
  if (minute == 0) {
    if (second <= 9) {
      time += `00:0${parseInt(second)}`
    } else {
      time += `00:${parseInt(second)}`
    }
  } else if (second <= 9) {
    time += `0${parseInt(second)}`
  } else {
    time += parseInt(second)
  }
  if (minute != 0) {
    if (minute > 9) {
      time = `${parseInt(minute)}:${time}`
    } else {
      time = `0${parseInt(minute)}:${time}`
    }
  }
  if (hour > 0) {
    time = `${parseInt(hour)}:${time}`
  } else {
    time = `00:${time}`
  }
  return time
}
export const GETDURATION = function (start, end) {
  let duration
  if (arguments.length > 1 && typeof end != 'object') {
    if (typeof start == 'string' && start.includes('-')) {
      start = new Date(start)
    }
    if (typeof end == 'string' && end.includes('-')) {
      end = new Date(end)
    }
    start = typeof start == 'object' ? start.getTime() : start
    end = typeof end == 'object' ? end.getTime() : end
    duration = end - start
  } else {
    duration = start || 0
  }
  if (duration <= 0) {
    if (end && typeof end == 'object') {
      const { totalTime } = end
      const h = Outil.timeFormat(Math.floor((totalTime) / 1000 / 60 / 60))
      const min = Outil.timeFormat(Math.floor((totalTime) % (1000 * 60 * 60) / 1000 / 60))
      const s = Outil.timeFormat(Math.floor((totalTime) % (1000 * 60) / 1000))
      return `${h}:${min}:${s}`
    }
    return '00:00:00'
  }
  // 求剩余多长时间
  if (end && typeof end == 'object') {
    const { totalTime } = end
    duration = totalTime - duration
  }
  if (duration < 0) duration = 0
  const h = Outil.timeFormat(Math.floor((duration) / 1000 / 60 / 60))
  const min = Outil.timeFormat(Math.floor((duration) % (1000 * 60 * 60) / 1000 / 60))
  const s = Outil.timeFormat(Math.floor((duration) % (1000 * 60) / 1000))
  // let ms =
  let remainTime = `${h}:${min}:${s}`
  if (remainTime != '00:00:00') {
    remainTime = `${remainTime}`
  }
  return remainTime
}

export const GETDURATIONNUM = function (start, end) {
  if (start == '') start = '2021-1-1 00:00:00'
  let startTime = new Date(start.replace(/-/g, '/')) // 开始时间
  startTime = startTime.getTime()
  let endTime = new Date(end.replace(/-/g, '/')) // 开始时间
  endTime = endTime.getTime()
  return (endTime - startTime) / 1000
}

export default {
  BTNSTATUS,
  WIDTHCLASS,
  SHOWICON,
  CANSUE,
  SHOWDEVICEIMG,
  RETURNSTATUS,
  SWITCHBUSSTATUS,
  BTNNAME,
  CHANGELANGUAGE,
  FORMATSORT,
  FORMATROLE,
  SETTINGTYPE,
  DATE,
  UTCDATE,
  MAPLOACTION,
  BITRATE,
  GETDURATION,
  DURATION,
  GETDURATIONNUM
}
